import { gql } from '@apollo/client';

/**
 * 「上门中」站点当前的派单信息（任务号 + 司机姓名 + 电话）。
 *
 * <p>只在跟进详情里按站点单点查询，**不供列表使用** —— 列表逐站调用会退化成 N 次查询。
 *
 * <p>与时间线里司机上门反馈(type=5)节点展示的司机**不是一回事**：
 * 那条是**快照**（当时是谁上的门，事后不该变），本查询是**实时值**（现在谁要来）。
 * 预约单被转派到别的任务时司机会换人，日志不会改，只有实时查才跟得上。
 *
 * <p>站点无在途派单时返回 null —— 线上存在一批 `link_status=6` 却无在途预约单的存量站点
 * （成因是取消任务/移出预约单不回退，代码已修但存量不自愈）。这不是错误，
 * 界面应显示「无在途派单信息」而不是空白：空白会被当成加载失败，明写出来运营才知道状态不对。
 */
export const GET_STATION_ONSITE_DISPATCH = gql`
  query GetStationOnsiteDispatch($cooperationWarehouseId: Long!) {
    getStationOnsiteDispatch(cooperationWarehouseId: $cooperationWarehouseId) {
      taskNumber
      driverName
      driverPhone
    }
  }
`;

export interface StationOnsiteDispatchDto {
  taskNumber: string | null;
  driverName: string | null;
  /** 来自账号表；账号停用/删除时为空，但任务号与姓名仍在 */
  driverPhone: string | null;
}

export interface GetStationOnsiteDispatchResponse {
  /** 无在途派单时为 null */
  getStationOnsiteDispatch: StationOnsiteDispatchDto | null;
}
